import React, { useState } from "react";
import { Grid, TextField, Button, Container } from "@mui/material";
import { useSelector } from "react-redux";
import Header from "components/Header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "services/api";

const Infos = () => {
  const mode = useSelector((state) => state.global.mode);

  const formatDateForInput = (date) => {
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${year}-${month}-${day}`;
  };

  const formatDateForDatabase = (date) => {
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  };

  const [formData, setFormData] = useState({
    title_left: "Autres informations / commentaires",
    title_right: "Signature GERANT et Visa ASUFOR",
    input_field: "",
    bottom_title: "Ce rapport doit être expédié au chef de Brigade au plus tard 10 jours après la fin du mois.",
    selectedDate: formatDateForInput(new Date()), // Set current date by default
  });

  const [confirmToast, setConfirmToast] = useState(false); // State to manage confirmation toast

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.input_field && !confirmToast) {
      const id = toast(
        ({ closeToast }) => (
          <div style={{ textAlign: 'center' }}>
            <p>Le champ de commentaire est vide. Souhaitez-vous mettre 'Rien à signaler' ?</p>
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                setFormData((prevData) => ({
                  ...prevData,
                  input_field: "Rien à signaler",
                }));
                setConfirmToast(true); // Set confirm toast state to true
                toast.dismiss(id);
                await submitForm();
              }}
              style={{ marginRight: '10px' }}
            >
              Oui
            </Button>
            <Button variant="contained" color="secondary" onClick={() => toast.dismiss(id)}>
              Non
            </Button>
          </div>
        ),
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          hideProgressBar: true,
        }
      );
    } else {
      await submitForm();
      setConfirmToast(false); // Reset confirm toast state after submission
    }
  };

  const submitForm = async () => {
    try {
      const response = await api.post(
        "/api/infos",
        {
          ...formData,
          selectedDate: formatDateForDatabase(
            new Date(formData.selectedDate)
          ),
        }
      );

      console.log("Form submitted:", response.data);

      toast.success("Formulaire soumis avec succès.");

      setFormData({
        title_left: "Autres informations / commentaires",
        title_right: "Signature GERANT et Visa ASUFOR",
        input_field: "",
        bottom_title:
          "Ce rapport doit être expédié au chef de Brigade au plus tard 10 jours après la fin du mois.",
        selectedDate: formatDateForInput(new Date()),
      });
    } catch (error) {
      console.error(
        "Erreur lors de la soumission du formulaire!",
        error
      );

      toast.error(
        error.response?.data?.error ||
        "Erreur lors de la soumission du formulaire. Veuillez réessayer."
      );
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2, ml: 3 }}>
      <Header
        title="Ajouter autre information"
        subtitle="Les champs sont obligatoires sauf le champs commentaire"
        sx={{ mb: 5 }}
      />
      <Grid container spacing={2} sx={{ mt: 4 }} justifyContent="center">
        <Grid item xs={8}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {[
                { name: "title_left", label: "Titre Gauche", disabled: true },
                { name: "title_right", label: "Titre Droit", disabled: true },
                { name: "input_field", label: "Commentez ici ..." },
                { name: "bottom_title", label: "Bas Titre", disabled: true },
              ].map((field) => (
                <Grid item xs={6} key={field.name}>
                  <TextField
                    label={field.label}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    required={field.name !== "input_field"}
                    fullWidth
                    disabled={field.disabled}
                  />
                </Grid>
              ))}
              <Grid item xs={6}>
                <TextField
                  label="Date"
                  name="selectedDate"
                  type="date"
                  value={formData.selectedDate}
                  onChange={handleChange}
                  fullWidth
                  sx={{
                    "& input::-webkit-calendar-picker-indicator": {
                      color: "darkgoldenrod",
                      filter: "invert(0.5) sepia(1) saturate(10) hue-rotate(5deg) brightness(1.1) contrast(1.2)",
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color={mode === "dark" ? "secondary" : "primary"}
                  size="large"
                  sx={{
                    width: "100%",
                  }}
                >
                  Ajouter
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Infos;

